"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETemplateType = exports.ETemplateTypesText = exports.EOptionalRelation = exports.EObjectProperty = exports.EMandatoryProperty = exports.EReservationKind = exports.EDefaultStatus = void 0;
var EDefaultStatus;
(function (EDefaultStatus) {
    EDefaultStatus["CONFIRMED"] = "CONFIRMED";
    EDefaultStatus["PLANNED"] = "PLANNED";
    EDefaultStatus["PRELIMINARY"] = "PRELIMINARY";
})(EDefaultStatus = exports.EDefaultStatus || (exports.EDefaultStatus = {}));
var EReservationKind;
(function (EReservationKind) {
    EReservationKind["PHYSICAL"] = "PHYSICAL";
    EReservationKind["PHYSICAL_DOUBLE"] = "PHYSICAL_DOUBLE";
    EReservationKind["ABSTRACT"] = "ABSTRACT";
    EReservationKind["ABSTRACT_DISPLAY"] = "ABSTRACT_DISPLAY";
})(EReservationKind = exports.EReservationKind || (exports.EReservationKind = {}));
var EMandatoryProperty;
(function (EMandatoryProperty) {
    EMandatoryProperty["MANDATORY"] = "MANDATORY";
    EMandatoryProperty["COMBINATION"] = "COMBINATION";
    EMandatoryProperty["OPTIONAL"] = "OPTIONAL";
})(EMandatoryProperty = exports.EMandatoryProperty || (exports.EMandatoryProperty = {}));
var EObjectProperty;
(function (EObjectProperty) {
    EObjectProperty["OBJECT"] = "OBJECT";
    EObjectProperty["VIRTUAL"] = "VIRTUAL";
    EObjectProperty["INCOMPLETE"] = "INCOMPLETE";
})(EObjectProperty = exports.EObjectProperty || (exports.EObjectProperty = {}));
var EOptionalRelation;
(function (EOptionalRelation) {
    EOptionalRelation["NONE"] = "NONE";
    EOptionalRelation["OPTIONAL"] = "OPTIONAL";
    EOptionalRelation["ABSTRACT"] = "ABSTRACT";
})(EOptionalRelation = exports.EOptionalRelation || (exports.EOptionalRelation = {}));
var ETemplateTypesText;
(function (ETemplateTypesText) {
    ETemplateTypesText["STANDARD"] = "STANDARD";
    ETemplateTypesText["NEVER"] = "NEVER";
    ETemplateTypesText["ALWAYS"] = "ALWAYS";
})(ETemplateTypesText = exports.ETemplateTypesText || (exports.ETemplateTypesText = {}));
var ETemplateType;
(function (ETemplateType) {
    ETemplateType["RESERVATION"] = "RESERVATION";
    ETemplateType["AVAILABILITY"] = "AVAILABILITY";
    ETemplateType["INFO_RESERVATION"] = "INFO_RESERVATION";
})(ETemplateType = exports.ETemplateType || (exports.ETemplateType = {}));
